import React from 'react';
import PropTypes from 'prop-types';

import UserLimitsButton from './UserLimitsButton';

const ConfigButtonWrapper = (props) => {
    if (props.kpi?.showLimitOffsetConfig) {
        return <UserLimitsButton {...props} />;
    }
    return null;
};
ConfigButtonWrapper.propTypes = {
    kpi: PropTypes.shape({
        showLimitOffsetConfig: PropTypes.bool,
    }),
};
export default ConfigButtonWrapper;
